import React from "react";

// components

import AppointmentTable from "components/Cards/AppointmentTable";

export default function Appointment() {
  return (
    <>
      <div className="flex flex-wrap mt-4">
        <div className="w-full mb-12 px-4">
          <AppointmentTable />
        </div>
      </div>
    </>
  );
}
